module.exports = __webpack_public_path__ + "Server-Disabled.AzureWebApp.f77c75b97bd41339074f1e43b2ca1247.hashedasset.svg";